import { render, staticRenderFns } from "./destroy-done.vue?vue&type=template&id=6a222d4f&scoped=true"
import script from "./destroy-done.vue?vue&type=script&lang=js"
export * from "./destroy-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a222d4f",
  null
  
)

export default component.exports